// extracted by mini-css-extract-plugin
export default {"signUpForm":"SignUpForm_signUpForm__BQhgg","formContent":"SignUpForm_formContent__gn+9l","formFields":"SignUpForm_formFields__a9Ehv","fadeIn":"SignUpForm_fadeIn__AyENd"};